exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".filter-grid[data-v-be10ba96] {\n  grid-template-columns: 6fr 2fr 2fr;\n  display: grid;\n  grid-gap: 2.5rem;\n  gap: 2.5rem;\n}\n.FilterBar__inner[data-v-be10ba96] {\n  max-width: 1152px;\n}\n.FilterBar--hide-filters .FilterBar__filters[data-v-be10ba96] {\n    display: none;\n}\n", ""]);

// exports
